/**
 * Retour du checkout vers la boutique.
 *
 * Le lien « panier » du checkout pointe vers /cart et n'est pas modifiable
 * depuis le thème (Checkout Extensibility ne l'expose pas). Comme la boutique
 * est configurée en cart_type = drawer, la page panier n'est plus une
 * destination : on renvoie donc vers la dernière page boutique visitée, tiroir
 * panier ouvert, et à défaut vers l'accueil.
 *
 * Sans JavaScript, la page panier reste servie normalement : c'est un
 * enrichissement, pas un prérequis.
 */
(() => {
  const FLAG = 'ax-open-cart';
  const LAST_PAGE_KEY = 'ax:last-store-page';
  const script = document.currentScript;
  const isCartPage = script?.dataset.cartPage === 'true';

  const read = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      // Navigation privée ou cookies bloqués : on retombe sur l'accueil.
      return null;
    }
  };

  const write = (key, value) => {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      /* idem */
    }
  };

  // Une cible n'est acceptable que si elle est interne et ne renvoie ni vers la
  // page panier (boucle de redirection) ni vers le checkout.
  const isSafeTarget = (path) =>
    typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.startsWith('/cart') &&
    !path.startsWith('/checkouts');

  if (isCartPage) {
    const stored = read(LAST_PAGE_KEY);
    const target = new URL(isSafeTarget(stored) ? stored : '/', window.location.origin);

    target.searchParams.set(FLAG, '1');

    // replace() et non assign() : la page panier ne doit pas rester dans
    // l'historique, sinon le bouton Retour y ramène.
    window.location.replace(target.toString());
    return;
  }

  write(LAST_PAGE_KEY, window.location.pathname + window.location.search);

  const params = new URLSearchParams(window.location.search);

  if (!params.has(FLAG)) return;

  // On retire le drapeau de l'URL avant tout : il ne doit ni être partagé, ni
  // rouvrir le tiroir à chaque rechargement.
  params.delete(FLAG);

  const query = params.toString();
  window.history.replaceState(
    {},
    '',
    window.location.pathname + (query ? `?${query}` : '') + window.location.hash
  );

  const openCartDrawer = () => {
    customElements.whenDefined('cart-drawer').then(() => {
      document.getElementById('cart-drawer')?.show();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartDrawer, { once: true });
  } else {
    openCartDrawer();
  }
})();
